import type { GrantOpportunityDocumentRole } from "@/api/grant_opportunity_documents";

export type GrantOpportunityLinkedDocumentComment = {
  id: number;
  municipality_id: number;
  document_id: number;
  user_id: number;
  parent_id: number | null;
  author_name: string;
  body: string;
  created_at: string;
  link_id: number;
  document_name: string;
  document_label: string | null;
  document_role: GrantOpportunityDocumentRole;
};

export async function listGrantOpportunityLinkedDocumentComments(
  municipalityId: number,
  opportunityId: number,
): Promise<GrantOpportunityLinkedDocumentComment[]> {
  const response = await fetch(
    `/api/v1/municipalities/${municipalityId}/grant_opportunities/${opportunityId}/linked_document_comments`,
    {
      credentials: "include",
      headers: { Accept: "application/json" },
    },
  );
  if (!response.ok) {
    throw new Error("Failed to load linked document comments");
  }
  return response.json();
}
